<template>
  <div class="card rounded-4">
    <div class="card-body">
      <div class="d-flex align-items-center mb-4">
        <img
          :src="ratingAvatarSrc"
          alt=""
          height="40"
          width="40"
          class="rounded-circle me-2"
        />
        <div>
          <p class="mb-1 text-subtitle">
            {{ rating.user.name.split(" ")[0] }}
          </p>
          <p class="text-label mb-0">
            {{ formattedDate }}
          </p>
        </div>
        <div class="ms-auto">
          <!-- <p
                  class="text-subtitle text-warning"
                  v-if="rating?.review_requested && !rating?.reviewed_by"
                >
                  Em análise
                </p>
                <p
                  v-else-if="!rating?.reviewed_by"
                  class="text-subtitle text-muted cursor-pointer"
                  @click="handleReport(rating)"
                >
                  Reportar
                </p> -->
          <p
            class="text-subtitle text-danger cursor-pointer"
            @click="onRemove(rating.id)"
          >
            Reportar
            <i class="fa-solid fa-trash-alt"></i>
          </p>
        </div>
      </div>
      <p class="text-paragraph text-wrap">{{ rating.description }}</p>
      <hr />

      <div class="d-flex align-items-center justify-content-between">
        <p class="text-paragraph mb-0">
          Este depoimento está<br />
          <span class="text-subtitle">{{
            rating.active ? "aparecendo" : "oculto"
          }}</span>
          no seu perfil
        </p>

        <span
          v-if="submitting"
          class="spinner-border spinner-border-sm me-2 text-secondary"
          role="status"
          aria-hidden="true"
        ></span>
        <SwitchInput
          v-else
          :id="`rating_${rating.id}`"
          :checked="rating.active"
          color="secondary"
          @handleChange="onChange(rating)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
  FileBaseUrl,
  type Rating,
} from "@phurshell/psiapp-frontend-core/domain";
import moment from "moment";
import { UserAvatar } from "@/constants/UserAvatar";

const props = defineProps<{ rating: Rating; submitting?: boolean }>();
const emit = defineEmits<{
  (e: "handleRemove", id: number): void;
  (e: "handleChange", item: Rating): void;
}>();

const formattedDate = computed(() =>
  props.rating.created_at
    ? moment(props.rating.created_at).format("DD/MM/YYYY")
    : "",
);

const ratingAvatarSrc = computed(() => {
  const img = String(props.rating?.user?.profile_image ?? "");
  return UserAvatar[img] ?? `${FileBaseUrl}${img}`;
});

function onRemove(id: number) {
  emit("handleRemove", id);
}

function onChange(item: Rating) {
  emit("handleChange", item);
}
</script>
